import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  html,
  body {
    width: 100%;
    line-height: 1.5;
  }

  body {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  body.fontLoaded {
    font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  #app {
    min-height: 100%;
    min-width: 100%;
  }

  p,
  label {
    font-family: Georgia, Times, 'Times New Roman', serif;
    line-height: 1.5em;
  }

  @keyframes blink {
    0% { opacity: 0; }
    15% { opacity: 1; }
    30% { opacity: 0; }
  }

  @keyframes blinkJob {
    0% { background-color: transparent; }
    50% { background-color: rgba(232, 232, 0, 0.2); }
    100% { background-color: transparent; }
  }
`;

export default GlobalStyle;
